"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import emprendimiento_banner from "../../styles/images/banner_emprendedores.webp";
import gestion_banner from "../../styles/images/banner_sistema_de_gestion_integral.webp";
import asesoria_banner from "../../styles/images/banner_asesoria.webp";
import icon_g_1 from "../../styles/iconos-3/asesoria.svg";
import icon_g_2 from "../../styles/iconos-3/sistema_de_gestion_integral.svg";
import icon_g_3 from "../../styles/iconos-3/emprendedores_blanco.svg";

const ServiciosComponent: React.FC = () => {
  return (
    <>
      <div className="testimonials-area">
        <div className="container-full">
          <Swiper
            slidesPerView={1}
            spaceBetween={25}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="testimonials-slides-two testimonial-nosotros"
          >
            <SwiperSlide>
              <div className="single-testimonials-box">
                <div className="row align-items-center pt-100 pb-75 px-4"  style={{backgroundImage: `URL(${emprendimiento_banner})`, backgroundSize: "cover", backgroundPosition: "center"}}>
                  <div className="col-lg-6 col-md-6 text-center">
                    <div className="img">
                      <img
                        src={icon_g_3}
                        alt="user"
                        width={300}
                        height={290}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <h5>EMPRENDEDORES</h5>
                    <p>
                      Nos hemos establecido como una empresa que apoya a
                      emprendedores e innovadores en el lanzamiento de nuevos
                      negocios. Por lo tanto, puedes confiar en nosotros para
                      impulsar el crecimiento de tus ideas y recibir el apoyo
                      que necesitas. Nuestra infraestructura y gran ánimo de
                      colaboración están a tu disposición para ayudarte a
                      alcanzar tus objetivos.
                    </p>
                    {/* <div className="info">
                      <h3>Lora Joly</h3>
                      <span>Founder at Envato</span>
                    </div> */}
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="single-testimonials-box">
                <div className="row align-items-center pt-100 pb-75 px-4"  style={{backgroundImage: `URL(${gestion_banner})`, backgroundSize: "cover", backgroundPosition: "center"}}>
                  <div className="col-lg-6 col-md-6 text-center">
                    <div className="img">
                      <img
                        src={icon_g_2}
                        alt="user"
                        className="img-icon"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <h5>SISTEMA DE GESTIÓN INTEGRAL</h5>
                    <p>
                      Nuestro sistema de gestión integral está enmarcado en la
                      búsqueda del cuidado de la salud, el medio ambiente y la
                      calidad, así como desarrollar proyectos sociales en donde
                      aportemos a quienes lo necesitan.
                    </p>
                    {/* <div className="info">
                      <h3>David Warner</h3>
                      <span>Founder at ThemeForest</span>
                    </div> */}
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="single-testimonials-box">
                <div className="row align-items-center pt-100 pb-75 px-4" style={{backgroundImage: `URL(${asesoria_banner})`, backgroundSize: "cover", backgroundPosition: "center"}}>
                  <div className="col-lg-6 col-md-6 text-center">
                    <div className="img">
                      <img
                        src={icon_g_1}
                        alt="user"
                        width={300}
                        height={290}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <h5>ASESORÍA</h5>
                    <p>
                      Asesoramos su operación en plantas de tratamiento de agua
                      Recomendamos los productos químicos adecuados de acuerdo
                      al tipo de industria al que pertenezca su empresa.
                    </p>
                    <p>
                      - Prestamos asesoría a nuestros clientes en el trámite del SICOQ
                    </p>
                    <p>
                      - Capacitamos a nuestros clientes y su equipo de trabajo en el manejo, prevención, uso de EPP y almacenamiento de los productos químicos.
                    </p>
                    <p>
                      - Asesoría en la creación y manejo de compostaje a partir de los residuos de diferentes procesos industriales.
                    </p>
                    {/* <div className="info">
                      <h3>James Anderson</h3>
                      <span>Founder at EnvyTheme</span>
                    </div> */}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default ServiciosComponent;
